import type { FaireProductEntity } from "../../entity_types/product";

export const bath_5: FaireProductEntity = {
  token: "bath-5",
  type: "product",
  name: "Vanilla Body Lotion",
  brandName: "Pure Soap Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4b4955ab73d7063dcdd78f8262fa0fc2c512b0c4250c3578bb527ee41b0e4ca7.webp",
  priceDollars: 14,
  msrpDollars: 22,
  freeShipping: true,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_beauty-all"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
